import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UserLiftPermissionService } from './usr-lift-permission.service';
import { UserLiftPermission } from '../models/user-lift-permission.model';

@Injectable({ providedIn: 'root' })
export class UserLiftPermissionResolver implements Resolve<UserLiftPermission> {
  constructor(
    private userLiftPermissionService: UserLiftPermissionService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const loginId = route.params.loginId;

    return this.userLiftPermissionService.getUserPermission(loginId);
  }
}
